import { SERVER_URI } from '../Constant/server';
import { apiPost, apiGet, apiPut } from '../utils/axios';

const ADD_MACHINE = SERVER_URI + '/machine/add';
const GET_MACHINE_DETAIL = SERVER_URI + '/machine/get-data';
const CHANGE_STATUS = SERVER_URI + '/machine/change-status/';
const UPDATE_MACHINE = SERVER_URI + '/machine/update/';
const MACHINE_ANIMATION_COLOR = SERVER_URI + '/machine/machine-animation-color/';
const CREATE_MACHINE_COMBO = SERVER_URI + '/add-machine-combo-product';
const UPDATE_MACHINE_COMBO = SERVER_URI + '/update-machine-combo-product/';
const GET_MACHINE_COMBO_PRODUCT = SERVER_URI + '/get-machine-combo-product';
export default {
    addMachine: async function (payload) {
        return apiPost(ADD_MACHINE, payload);
    },
    getMachineDetail: async function (payload) {
        //console.log('ppp',payload);
        return apiPost(GET_MACHINE_DETAIL, payload);
    },
    UpdateStatus: async function (id) {
        return apiGet(CHANGE_STATUS + id)
    },
    updateMachineRecord: async function (id, payload) {
        return apiPut(UPDATE_MACHINE + id, payload)
    },
    GetAnimation: async function () {
        return apiGet(MACHINE_ANIMATION_COLOR)
    },
    createMachineCombo: async function (payload) {
        return apiPost(CREATE_MACHINE_COMBO, payload);
    },
    updateMachineCombo: async function (id, payload) {
        console.log('sssssssssssssssss',id,payload);
        return apiPut(UPDATE_MACHINE_COMBO + id, payload);
    },
    getMachineComboProduct: async function (payload) {
        return apiPost(GET_MACHINE_COMBO_PRODUCT, payload);
    },
};
